var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.srcMobile,
      "media": "(max-width: 767px)"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "srcset": _vm.srcDesktop,
      "media": "(min-width: 768px)"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.srcMobile,
      "alt": _vm.alt
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };